export const TERMS_OF_SERVICE_URL: string = "https://brightfunded.com/terms-and-conditions";
